<template lang="pug">
  on-viewport(:thresholds="thresholds")
    template(#default="{ shown, invalidBrowser }")
      with-effect(:shown="shown" :invalid-browser="invalidBrowser" :name="name" :delay="delay")
        slot
</template>

<script>
import OnViewport from "./OnViewport";
import WithEffect from "./WithEffect";

export default {
  components: {
    OnViewport,
    WithEffect,
  },
  props: {
    name: {
      type: String,
      default: "fadein",
    },
    delay: {
      type: Number,
      default: 0,
    },
    thresholds: {
      type: Array,
      default: () => [0.5, 0.5],
    },
  },
};
</script>
